<template>
  <div class="contain">
    <div
      :class="{ recordBox: true, ind: true, bgColor: goodsList.length !== 0 }"
    >
      <yNavBar title="搜索" />
      <van-search
        id="searchInput"
        background="#F7F8F9"
        placeholder="请输入项目关键词"
        show-action
        v-model="keyword"
        @input="onInput"
        @cancel="onCancel"
        @search="onSearch"
      >
        <div slot="action" @click="onClickLeft" class="searchbtntext">取消</div>
      </van-search>
      <div v-if="goodsList.length === 0">
        <div class="history" v-if="hisToryWord.length !== 0 && keyword === ''">
          <div class="model1">
            <div class="label">历史搜索</div>
            <div class="itembox">
              <div
                class="item"
                v-for="(i, index) in hisToryWord"
                :key="index + 'c'"
                @click="handleLabelSearch(item)"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div class="history2" v-if="hotWord.length !== 0 && keyword === ''">
          <div class="model1">
            <div class="label">热门推荐</div>
            <div class="itembox">
              <div
                class="item"
                v-for="(i, index) in hotWord"
                :key="index + 'd'"
                @click="handleLabelSearch(item.keyStr)"
              >
                {{ item.keyStr }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pro-box" v-if="newsList.length !== 0">
        <IndexCard
          :cardData="i"
          v-for="(i, index) in newsList"
          :key="index + 'f'"
        ></IndexCard>
      </div>
      <loading
        v-if="isLodingShow && keyword !== ''"
        :isShow="isLodingShow"
      ></loading>
      <van-empty
        description="暂无数据"
        v-if="newsList.length === 0 || keyword === ''"
      />
    </div>
  </div>
</template>
<script>
import { getYaxNewsList } from "@/api/index";
import IndexCard from "@/views/Index-components/IndexCard.vue";
export default {
  data() {
    return {
      keyword: "",
      newsList: [],
      hisToryWord: [],
      goodsList: [],
      hotWord: [],
      isLodingShow: false,
    };
  },
  components: {
    IndexCard,
  },
  methods: {
    onInput(e) {
      var reqData = {
        qkey: e,
      };
      getYaxNewsList(reqData).then((res) => {
        if (res.data.state === 0) {
          this.newsList = res.data.data.newsList;
        } else {
          this.newsList = [];
        }
      });
    },
    onSearch() {},
    onCancel() {
      this.$goback();
    },
    onClickLeft() {
      this.$goback();
    },
  },
  computed: {},
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
.cardActive {
  font-size: 19px;
  border: none;
  color: black;
  border-bottom: 0 !important;
}

.bgColor {
  background: #f7f8f9;
}

view .van-search {
  box-sizing: border-box !important;
  padding: 16px 19px;
}

.van-search__content {
  background-color: rgb(255, 255, 255) !important;
  border-radius: 20px !important;
}

.searchbtntext {
  margin-left: 10px;
}

.nomore {
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: #8f8f8f;
  line-height: 20px;
  margin: 15px 0;
}

.recordBox {
  height: 100vh;
}

.history {
  padding: 16px 13px;
  box-sizing: border-box;

  .label {
    font-size: 13px;
    font-weight: bold;
    color: #333333;
  }
}

.history2 {
  padding: 12px;
  box-sizing: border-box;

  .label {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }
}

.itembox {
  display: flex;
  flex-wrap: wrap;
  /* 当空间不足时，自动换行 */
  margin-top: 11px;
}

.item {
  flex: 0 0 auto;
  /* 让子项根据内容自动扩展宽度 */
  font-size: 12px;
  font-weight: 500;
  color: #7b7b7b;
  padding: 2px 7px;
  background: #f8f8f8;
  border-radius: 50px;
  margin-right: 20px;
  margin-bottom: 10px;
  /* 添加下边距以增加间隔 */
}

.pro-box {
  padding: 5px 18px;
  box-sizing: border-box;
}
</style>
